module.exports = __webpack_public_path__ + "img/wel_text.0c8cec7b.png";